import { Component, StrictMode } from "react";
import { createRoot } from "react-dom/client";
import RootApp from "./RootApp.jsx";
import DriverApp from "./driver/DriverApp.jsx";
import { DriverToastHost } from "./driver/DriverToastHost.jsx";
import { registerDriverPwa } from "./driver/driver-pwa.js";
import "leaflet/dist/leaflet.css";
import "./styles/tokens.css";
import "./styles/app.css";
import "./styles/modern.css";
import "./styles/data-master.css";
import "./styles/orders.css";
import "./styles/fleet-orders.css";
import "./styles/do-preparations.css";
import "./styles/driver.css";

class DriverRuntimeBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("Sedulur Dalan render failure.", error, info);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="driver-runtime-fallback" role="alert">
        <section>
          <h1>Aplikasi perlu dimuat ulang</h1>
          <p>Data dan foto yang tersimpan di perangkat tetap aman.</p>
          <button onClick={() => window.location.reload()} type="button">Muat ulang aplikasi</button>
          <small>Kode bantuan: DRIVER_UI_RENDER_ERROR</small>
        </section>
      </main>
    );
  }
}

const isDriverApp = window.location.pathname.startsWith("/sedulurdalan");

if (isDriverApp && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    registerDriverPwa().catch((error) => {
      console.warn("Driver service worker registration failed.", error);
    });
  });
}

createRoot(document.getElementById("root")).render(
  <StrictMode>
    {isDriverApp ? <DriverRuntimeBoundary><DriverToastHost /><DriverApp /></DriverRuntimeBoundary> : <RootApp />}
  </StrictMode>,
);
